function initRptStates($stateProvider) {

	$stateProvider.state('home.reportClientList', {
		url : "/reportClient/{idClient:int}/plansampling/{idPlan:int}/list",
		templateUrl : "views/rpt/reportClient.list.html",
		controller: "reportClientListCtrl",
		data : {
			permissions : {
				only : [ ROLE_TYPE.COMMERCIAL_MANAGER.code, ROLE_TYPE.CLIENT.code, ROLE_TYPE.TECHNICAL_PROFESSIONAL.code ]
			}
		}
	}).state('home.reportHome', {
		url : "/reports",
		templateUrl : "views/rpt/report.home.html",
		controller: "reportHomeCtrl",
		data : {			
			permissions : {
				only : [ ROLE_TYPE.COMMERCIAL_MANAGER.code,  ROLE_TYPE.ACCOUNTING.code]
			}
		}
	}).state('home.reportCancel', {
		data : {			
			permissions : {
				only : [ ROLE_TYPE.COMMERCIAL_MANAGER.code]
			}
		}
	});
}